<template>
  <span class="country-label">
    <span
      v-if="country.flag"
      class="country-label-flag"
      aria-hidden="true"
    >{{ country.flag }}</span>
    <abbr
      v-if="compact && country.code"
      :title="country.name"
    >{{ country.code }}</abbr>
    <span
      v-else
      class="country-label-name"
    >{{ country.name }}</span>
  </span>
</template>
<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { countryDetails } from '@/utils/countryDisplay';
const props = defineProps({ value: { type: String, default: '' }, compact: { type: Boolean, default: false } });
const { locale } = useI18n();
const country = computed(() => countryDetails(props.value, locale.value));
</script>
<style scoped>
@reference '../../styles/refresh.css';
.country-label { @apply tw:inline-flex tw:items-center tw:gap-2; min-width:0;max-width:100%;vertical-align:middle; }
.country-label-flag { flex-shrink:0;font-size:1.45em;line-height:1.2;font-family:'Apple Color Emoji','Segoe UI Emoji','Noto Color Emoji',sans-serif; }
.country-label-name { min-width:0;overflow-wrap:anywhere; }
.country-label abbr { cursor:default;text-decoration:none; }
</style>
